import { Auction, GetOntologyType } from "core/types";
import Translations from "translations/types";
import { AdmissionsGeneralInformation } from "./AdmissionsPatientCard";
import { PatientProfileInfoCard } from "./shared";

export function AdmissionsPatientCardPrint({
  auction,
  getOntology,
  isSealdOnly,
  translations,
  withEncryptionAccess,
}: {
  auction: Auction;
  translations: Translations;
  isSealdOnly: boolean;
  withEncryptionAccess: boolean;
  getOntology: GetOntologyType;
}) {
  return (
    <PatientProfileInfoCard
      title={
        translations.careproviderApp.recareAdmissionsForm.patientInformation
          .pageTitle
      }
    >
      <AdmissionsGeneralInformation
        getOntology={getOntology}
        isSealdOnly={isSealdOnly}
        translations={translations}
        value={auction}
        withEncryptionAccess={withEncryptionAccess}
      />
    </PatientProfileInfoCard>
  );
}
